<template lang="pug">
  .searching(v-if="(products && products.loading) || loading")
    Spinner(:size="10" :thickness="2")
  .found(v-else-if="query")
    template(v-if="products && products.items && products.items.length")
      .alert
        p Hier die Produkte zu Ihrer Suche nach "<b>{{ query }}</b>"
      ul.products(ref="list")
        li.item(
          v-for="(item, i) in items"
          :class="{'is-active': currentProduct && item.id === currentProduct.id}"
        )
          ProductPreview(
            :key="item.id"
            :product="item"
            :active="currentProduct && item.id === currentProduct.id"
            :display="displaySetting"
            @got-articles="articles => setArticles(i, articles)"
          )
          //- Matrix(:item="item")
      Pagination(
        v-if="pageInfo && pageInfo.lastPage > 1"
        :last-page="pageInfo.lastPage"
        :current-page="pageInfo.currentPage"
        nav-class="pagination is-rounded is-centered"
        @change="changePage"
      )
        template(v-slot:prev)
          span.icon
            i.fas.fa-arrow-left
        template(v-slot:next)
          span.icon
            i.fas.fa-arrow-right
    .alert.warning(v-else)
      p Zu der Suche nach "<b>{{ query }}</b>" konnten keine Produkte gefunden werden
</template>

<script>
import CategoryProducts from './LazyCategoryProducts';

import { get, cloneDeep } from '@/helpers';

export default {
    name: 'ProductSearchResults',
    extends: CategoryProducts,
    data: () => ({
        // ...
    }),
    watch: {
        '$route.query'(query) {
            window.scrollTo(0, 0);
            this.currentPage = get(query, `P${this.section.id}`) || 1;
            this.refetch(this.query);
        }
    },
    computed: {
        query() {
            return get(this.$route, 'query.s');
        }
    },
    methods: {
        refetch(query) {
            if (!query) return false;
            this.loading = true;

            const shop = get(this.cms, 'shop.id');
            const payload = {
                pageInfo: {
                    currentPage: this.currentPage,
                    perPage: 6
                },
                filters: [
                    {
                        key: 'shop',
                        match: shop.toString()
                    },
                    {
                        key: 'status',
                        match: 'enabled'
                    },
                    {
                        key: 'query',
                        like: this.query
                    },
                    {
                        key: 'qty_sum',
                        from: 1
                    }
                ],
                order: 'nr',
                direction: 'asc'
            };

            this.fetchProducts(payload).then(response => {
                if (response.pageInfo.currentPage > response.pageInfo.lastPage) {
                    this.changePage(response.pageInfo.lastPage);
                    return;
                }

                const products = cloneDeep(response);
                const container = document.querySelector('.preorder-columns > .column.left > .ps');
                if (container) container.scrollTop = 0;

                if (products.items && products.items.length) {
                    products.items.forEach((product, i) => {
                        product.position = i + 1;
                    });
                }

                this.products = products;
                // this.insertProducts({ products });
                this.loading = false;
            });
        }
    },
    mounted() {
        this.$nextTick(() => {
            if (this.query) {
                this.refetch(this.query);
            } else {
                this.products.loading = false;
            }
        });
    }
};
</script>

<style lang="sass" scoped>
.searching
  min-height: 4rem

.alert
  margin-bottom: 1rem

.products ::v-deep .arrow-container
  display: none
</style>
